import type { Dict } from '../index.js';

/** Arabic: bank details for salary transfers. Keys are the exact English text. */
export const bank: Dict = {
  'Bank details': 'البيانات البنكية',
  'Add bank details': 'إضافة البيانات البنكية',
  'Edit bank details': 'تعديل البيانات البنكية',
  'Remove bank details': 'حذف البيانات البنكية',
  'Remove bank details?': 'حذف البيانات البنكية؟',
  'No bank details': 'لا توجد بيانات بنكية',
  'Name on the bank account': 'الاسم كما في الحساب البنكي',
  Bank: 'البنك',
  'Bank name': 'اسم البنك',
  'Account number': 'رقم الحساب',
  IBAN: 'رقم الآيبان (IBAN)',
  'SWIFT / BIC': 'رمز السويفت (SWIFT / BIC)',
  'SWIFT / BIC (optional)': 'رمز السويفت (SWIFT / BIC) — اختياري',
  'Updated {date} by {name}.': 'آخر تحديث {date} بواسطة {name}.',
  'Only administrators with payroll access see these details. Payslips show only the last 4 characters.':
    'لا يرى هذه البيانات إلا المسؤولون الذين لديهم صلاحية الرواتب. تُظهر قسائم الرواتب آخر 4 خانات فقط.',
  "Add {name}'s bank account to include it in the bank transfer list on the Payroll page.":
    'أضف الحساب البنكي لـ {name} ليظهر في كشف التحويلات البنكية في صفحة الرواتب.',
  'Exactly as the bank writes it — transfers with a different name can be rejected.':
    'تمامًا كما يكتبه البنك — قد تُرفض التحويلات إذا اختلف الاسم.',
  'Needed for transfers from outside Egypt.': 'مطلوب للتحويلات من خارج مصر.',
  'An Egyptian IBAN starts with EG and has 29 characters. Spaces are fine — the check digits are verified.':
    'يبدأ الآيبان المصري بـ EG ويتكوّن من 29 خانة. لا مشكلة في المسافات — يتم التحقق من خانات التحقق.',
  'Enter the account number, the IBAN, or both.': 'أدخل رقم الحساب أو الآيبان أو كليهما.',
  'Bank transfer list (Excel)': 'كشف التحويلات البنكية (Excel)',
  'Bank details added': 'إضافة بيانات بنكية',
  'Bank details changed': 'تعديل البيانات البنكية',
  'Bank details removed': 'حذف البيانات البنكية',
  // Validation messages (packages/shared/src/payroll.ts)
  'Write the name exactly as it appears on the bank account': 'اكتب الاسم تمامًا كما يظهر في الحساب البنكي',
  'Enter the bank name': 'أدخل اسم البنك',
  'Use only digits, letters and dashes (4–34 characters)': 'استخدم الأرقام والحروف والشرطات فقط (من 4 إلى 34 خانة)',
  'This IBAN is not valid — check it against the bank letter (an Egyptian IBAN is EG + 27 digits)':
    'رقم الآيبان غير صحيح — راجعه مع خطاب البنك (الآيبان المصري هو EG + 27 رقمًا)',
  'A SWIFT / BIC code has 8 or 11 letters and digits': 'رمز السويفت يتكوّن من 8 أو 11 حرفًا ورقمًا',
  'Enter the account number or the IBAN': 'أدخل رقم الحساب أو الآيبان',
};
